var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.4444V6.55556C1 5.08213 1.58532 3.66905 2.62718 2.62718C3.66905 1.58532 5.08213 1 6.55556 1H15.4444C16.9179 1 18.3309 1.58532 19.3728 2.62718C20.4147 3.66905 21 5.08213 21 6.55556V15.4444C21 16.9179 20.4147 18.3309 19.3728 19.3728C18.3309 20.4147 16.9179 21 15.4444 21H6.55556C5.08213 21 3.66905 20.4147 2.62718 19.3728C1.58532 18.3309 1 16.9179 1 15.4444Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.7773C16 13.7773 14.3333 15.9996 11 15.9996C7.66667 15.9996 6 13.7773 6 13.7773",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11073 8.77908C6.96339 8.77908 6.82208 8.72055 6.71789 8.61636C6.61371 8.51218 6.55518 8.37087 6.55518 8.22352C6.55518 8.07618 6.61371 7.93487 6.71789 7.83069C6.82208 7.7265 6.96339 7.66797 7.11073 7.66797C7.25807 7.66797 7.39938 7.7265 7.50357 7.83069C7.60776 7.93487 7.66629 8.07618 7.66629 8.22352C7.66629 8.37087 7.60776 8.51218 7.50357 8.61636C7.39938 8.72055 7.25807 8.77908 7.11073 8.77908ZM14.8885 8.77908C14.7412 8.77908 14.5999 8.72055 14.4957 8.61636C14.3915 8.51218 14.333 8.37087 14.333 8.22352C14.333 8.07618 14.3915 7.93487 14.4957 7.83069C14.5999 7.7265 14.7412 7.66797 14.8885 7.66797C15.0359 7.66797 15.1772 7.7265 15.2813 7.83069C15.3855 7.93487 15.4441 8.07618 15.4441 8.22352C15.4441 8.37087 15.3855 8.51218 15.2813 8.61636C15.1772 8.72055 15.0359 8.77908 14.8885 8.77908Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuest);
export default __webpack_public_path__ + "static/media/guest.e4e2ee2c97b343de6bdc02f4a9202c0a.svg";
export { ForwardRef as ReactComponent };